import { apiRequest } from "./client";
import type { PublishedDefinition, Report } from "../types";

export const viewerApi = {
  listReports: () => apiRequest<Report[]>("/api/v1/viewer/reports"),
  getPublished: (id: string) =>
    apiRequest<PublishedDefinition>(`/api/v1/viewer/reports/${id}/published`),
  getData: (id: string) => apiRequest<Record<string, unknown>>(`/api/v1/viewer/reports/${id}/data`),
};
